module.exports = __webpack_public_path__ + "img/3.c34001fd.png";